import { Permission } from '@/lib/permissions/v1'
import { Route } from '@/composables/route'

export const setRouteQueries = async (route: Route) => {
    await route.addSortItem({
        column: 'date',
        direction: 'desc',
    })

    route.limit.value = 999999999
}

export enum CompanyStatementRouteName {
    Index = 'company.statement.index',
    Notes = 'company.statement.notes',
}

export default {
    path: 'statement',
    name: CompanyStatementRouteName.Index,
    component: () => import('@/views/company/statement/Index.vue'),
    meta: {
        label: 'Company Statement',
        auth: true,
        permission: Permission.CompanyStatementView,
    },
    children: [
        {
            path: 'notes',
            name: CompanyStatementRouteName.Notes,
            component: () => import('@/views/company/statement/Index.vue'),
            meta: {
                label: 'Company Statement Notes',
                auth: true,
                permission: Permission.NoteViewAny,
            },
        },
    ],
}
